export default __webpack_public_path__ + "static/media/icon-linkedin.2d60f9ac.svg";